import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';

@Component({
    selector: 'dashboard-home',
    template: require('./dashboard.home.html'),
    styles: [require('./dashboard.home.css')]
})
export class DashboardHome implements OnInit {
    public dashboards: Array<any> = [];
    constructor(private dataservice: DataService, private router: Router) {}

    ngOnInit() {
    	//console.log("dashboard home init called");
        this.dashboards = this.dataservice.dashboards;
        var data
        this.dataservice.getConfiguration().subscribe(dashboards => this.dashboards = dashboards)
        //console.log("dashboards", this.dashboards);
    }

    onSelect(dashboard: any) {
        //let id: string = event.currentTarget.id;
        let routeTemplate: string = '';
        for (let i = 0; i < this.dashboards.length; i++) {
            if (this.dashboards[i].template === dashboard.template) {
                routeTemplate = dashboard.template
                break;
            }
        }

        this.router.navigate(['/' + routeTemplate + '/' + dashboard.id]);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/dashboard/dashboard.home.ts